export default class DictsAdapter {
  public static sortByShortTitle(data1: any, data2: any) {
    return data1.shortTitle > data2.shortTitle ? 1 : -1
  }
  public static sortByShortGroup(data1: any, data2: any) {
    return data1.group > data2.group ? 1 : -1
  }
}
